
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class";   

import "@/store/modules/application";
const applicationState = namespace("Application");

import StepBase from "../StepBase.vue";
import FinancialStatement from "./FinancialStatement.vue";
import IncomeInformation from "./IncomeInformation.vue";
import ChangesIncomeFs from "./ChangesIncomeFS.vue";
import IncomeSummaryFs from "./IncomeSummaryFS.vue";
import DisclosureInformationFs from "./DisclosureInformationFS.vue";
import ExpensesFs from "./ExpensesFS.vue";
import DebtsFs from "./debtsFSComponent/DebtsFS.vue";
import AssetsFs from "./AssetsFS.vue";
import RealEstateFs from "./realEstateFSComponent/RealEstateFS.vue";
import CarsBoatsVehiclesFs from "./carsBoatsVehiclesFSComponent/CarsBoatsVehiclesFS.vue";
import CashAssetsFs from "./cashAssetsFSComponent/CashAssetsFS.vue";
import InvestmentsFs from "./investmentsFSComponent/InvestmentsFS.vue";
import LoansCreditsFs from "./loansCreditsFSComponent/LoansCreditsFS.vue";
import OtherAssetsFs from "./otherAssetsFSComponent/OtherAssetsFS.vue";
import DispositionAssetsFs from "./DispositionAssetsFS.vue";
import IncomeOtherPersonHouseholdFs from "./incomeOtherPersonHouseholdFSComponent/IncomeOtherPersonHouseholdFS.vue";
import ContributionTowardExpensesFs from "./ContributionTowardExpensesFS.vue";
import UndueHardshipFs from "./undueHardshipFSComponent/UndueHardshipFS.vue";
import UnusuallyHighExpensesFs from "./UnusuallyHighExpensesFS.vue";
import LegalDutyDependentChildFs from "./legalDutyDependentChildFSComponent/LegalDutyDependentChildFS.vue";
import LegalDutyAnotherPersonFs from "./legalDutyAnotherPersonFSComponent/LegalDutyAnotherPersonFS.vue";
import OtherCircumstancesFs from "./OtherCircumstancesFS.vue";
import AffidavitFs from "./AffidavitFS.vue";
import AboutAffiantFs from "./AboutAffiantFS.vue";
import FilingFs from "./FilingFS.vue";
import ElectronicFilingStatementFs from "./ElectronicFilingStatementFS.vue";
import ReviewYourAnswersFs from "./reviewFS/ReviewYourAnswersFS.vue";
import PreviewFormsFs from "./reviewFS/PreviewFormsFS.vue";
import PreviewFormsFsEfsp from "./reviewFS/PreviewFormsFsEFSP.vue";

import { stepInfoType } from "@/types/Application";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";

@Component({
    components:{
        StepBase,        
        FinancialStatement,
        IncomeInformation,        
        ChangesIncomeFs,
        IncomeSummaryFs,
        DisclosureInformationFs,
        ExpensesFs,
        DebtsFs,
        AssetsFs,
        RealEstateFs,
        CarsBoatsVehiclesFs,
        CashAssetsFs,
        InvestmentsFs,
        LoansCreditsFs,
        OtherAssetsFs,
        DispositionAssetsFs,
        IncomeOtherPersonHouseholdFs,
        ContributionTowardExpensesFs,
        UndueHardshipFs,
        UnusuallyHighExpensesFs,
        LegalDutyDependentChildFs,
        LegalDutyAnotherPersonFs,
        OtherCircumstancesFs,
        AffidavitFs,
        AboutAffiantFs,       
        FilingFs,
        ElectronicFilingStatementFs,
        ReviewYourAnswersFs,
        PreviewFormsFs,
        PreviewFormsFsEfsp
    }
})
export default class FinancialStatementStep extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

}
